if(!customElements.get('accordion-component')){
    class AccordionComponent extends HTMLElement {
        constructor() {
            super();
            
            this.IsOpen = !!(this.dataset.state.toLowerCase() === "open")
            this.OpenButton = this.querySelector('[data-opener]')
            this.Content = this.querySelector('[data-content')


            this.OpenButton.addEventListener('click', () => {
                this.toggle()
            })
        }

        // Listen For Theme Events of Type CloseAccordions From The Accordion Group
        cartUpdateUnsubscriber = undefined;
        connectedCallback() {
            if (this.dataset.accordionGroup) {
                this.cartUpdateUnsubscriber = SubscribeToEvent(`CloseAccordions-${this.dataset.accordionGroup}`, (eventData) => {
                    this.OnEvent(eventData)
                });
            }
            this.SetInitial()
        }
        disconnectedCallback() {
            if (this.cartUpdateUnsubscriber) {
                this.cartUpdateUnsubscriber();
            }
        }
        OnEvent(eventData) {
            if(eventData.opener !== this) {
                this.Close()
            }
        }

        SetInitial() {
            this.style.setProperty('--OpenHeight', `${this.Content.scrollHeight}px`);
        }

        toggle() {
            this.IsOpen ? this.Close() : this.Open()
        }

        Open() {
            if (this.dataset.accordionGroup) {
                TriggerEvent(`CloseAccordions-${this.dataset.accordionGroup}`, {opener: this, group: this.dataset.accordionGroup})
            }
            this.style.setProperty('--OpenHeight', `${this.Content.scrollHeight}px`);
            this.IsOpen = true;
            this.dataset.state = 'Open';
        }

        Close() {
            this.IsOpen = false;
            this.dataset.state = 'Closed'
        }
    }
    customElements.define('accordion-component', AccordionComponent);
}